










































































































































import Vue, { PropOptions } from 'vue'
import { SocialPreviewState } from '@/socialPreview/types'
import {
  TWITTER_SHARE_URL,
  FACEBOOK_SHARE_URL,
  LINE_SHARE_URL,
  TWITTER_SHARE_MESSAGE,
  TWITTER_HASHTAGS,
  FACEBOOK_APP_ID
} from '@/common/constants'
import { queryString } from '@/common/queryString'
import { clipboardCopy } from '@/common/copy'

export default Vue.extend({
  props: {
    data: {
      type: [Object, null],
      default: null
    } as PropOptions<SocialPreviewState>
  },
  computed: {
    hasShareContent(): boolean {
      return !!this.data && !!this.data.hasStock && !!this.data.shareUrl
    },
    hasFirstSelectedOption(): boolean {
      return !!this.data && !!this.data.firstSelectedOption
    },
    hasSecondSelectedOption(): boolean {
      return !!this.data && !!this.data.secondSelectedOption
    },
    hasSelectedColorPattern(): boolean {
      return !!this.data && !!this.data.selectedColorPattern
    },
    editPattern(): string {
      if (!this.data!.selectedEditPattern || !this.data!.selectedEditPattern.namingEditors) return ''

      return this.data!.selectedEditPattern.namingEditors.map(item => {
        return item.displayName
      }).join('・')
    },
    productUrl(): string {
      return this.data!.productUrl ?? ''
    },
    twitterUrl(): string {
      if (!this.data || !this.data.shareUrl) return ''

      const query = queryString.toString({
        text: encodeURIComponent(
          `${TWITTER_SHARE_MESSAGE}\n${this.data!.productShortDisplayName}`
        ),
        url: encodeURIComponent(this.data.shareUrl),
        hashtags: TWITTER_HASHTAGS.join(',')
      })
      return `${TWITTER_SHARE_URL}?${query}`
    },
    facebookUrl(): string {
      if (!this.data || !this.data.shareUrl) return ''

      const query = queryString.toString({
        app_id: FACEBOOK_APP_ID,
        display: 'popup',
        href: encodeURIComponent(this.data.shareUrl),
        redirect_uri: encodeURIComponent(this.data.shareUrl)
      })
      return `${FACEBOOK_SHARE_URL}?${query}`
    },
    lineUrl(): string {
      if (!this.data || !this.data.shareUrl) return ''

      const query = queryString.toString({
        url: encodeURIComponent(this.data.shareUrl)
      })
      return `${LINE_SHARE_URL}?${query}`
    }
  },
  methods: {
    linkCopy() {
      if (!this.data || !this.data.shareUrl) return ''

      clipboardCopy(this.data.shareUrl)
      alert('リンクをコピーしました')
    }
  }
})
